import { createHttpInstance } from '~/common/utils/http';

const httpInstance = createHttpInstance('perm', { path: '/v1' });

export default httpInstance;
